
import lazyload from "@/directives/lazyload";
import Jessica from "@/assets/images/landing/img/Jessica.png";
import Kelly from "@/assets/images/landing/img/Kelly.png";
import EricJ from "@/assets/images/landing/img/EricJ.png";
import LogoAmerican from "@/assets/images/landing/svg/flag-american.svg";
export default {
  data() {
    return {
      stories: [
        {
          name: "Jessica K.",
          text:
            'I just had this feeling that something was going on.<br> There had been a shift in the way he acted, it wasn’t something drastic, just different. I told my best friend about it and she suggested I check out what he was up to online. I felt weird about it at first but my sense that something had changed but not in a good way wasn’t going away.<br>I decided to do a free scan search on <span class="span--text-bold">iFindCheaters</span> and was super anxious. The trial shows you how it works and gives you results for some of the vanilla dating sites out there. He wasn’t on any of those, but I couldn’t deny my gut feeling. It cost less than lunch at a food truck to get the full report.<br>I was glad I did because my gut was right. He had active accounts on quite a few sites. If he was looking to meet other people there obviously was any point continuing to go out with him. At least now I know there is a way I can get info about potential boyfriends and protect myself!',
          imgMain: Jessica,
          imgSecond: Kelly,
          imgThird: EricJ,
          logo: LogoAmerican,
        },
        {
          name: "Kelly V.",
          text:
            'He was so attentive, he noticed little things that made me feel right away like I was the center of his world. But then for a few days he just disappeared. He didn’t answer his phone or respond to texts or emails. When I asked him about that he apologized and said his work was really strict about personal calls and stuff. I don’t know why but my instincts told me something was going on. I did a <span class="span--text-bold">Dating/Alternative Lifestyle Sites</span> search with his email address. I’m not sure what I was expecting but it definitely was not what I discovered. He had profiles on two fetish sites as a submissive seeking dominant women. At first I was kind of freaked out but thinking about it made me curious and kind of excited.<br> On our next date I told him I thought he needed some discipline… He took my hand and looked at me like he was seeing me for the first time. He just opened up and since then I have discovered a whole new side of myself. In this case knowledge really was power!',
          imgMain: Kelly,
          imgSecond: EricJ,
          imgThird: Jessica,
          logo: LogoAmerican,
        },
        {
          name: "Eric J.",
          text:
            'I met her at a Big Brothers – Big Sisters event. She seemed so cool and grounded, not like those chicks that are all about the “look”. She related so well to the kids, everyone thought she was great. I asked her out, casually, and we had a blast so it surprised me when she said no the fifth time I asked her out. I felt weird because I thought we were really connecting. It is like they say, you always want what you can’t have, right? One of my bro’s said I should track her down on social media so I decided to do a <span class="span--text-bold">Social Media & Mobile<br> Chat/Hook-up Apps search.</span> She had at least five different profiles; okay we weren’t serious or anything but every profile was like a different person. It was definitely her, same face, but very different attitude. My life is complicated already so I kind of feel like I dodged a bullet with that one. Now I do my research before making  a move.',
          imgMain: EricJ,
          imgSecond: Jessica,
          imgThird: Kelly,
          logo: LogoAmerican,
        },
      ],
      transitionClass: "list-next",
      pageNumber: 0,
    };
  },
  methods: {
    prevPage() {
      this.pageNumber--;
      this.transitionClass = "list-prev";
    },
    nextPage() {
      this.pageNumber++;
      this.transitionClass = "list-next";
    },
  },
  directives: {
    lazyload,
  },
};
